import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { ConfirmationField, Timer, useConfirmCode } from '@features/payment/confirm-code';
import { useResendCode } from '@features/payment/resend-code';
import { useAuthDataStore } from '@entities/user';
import { PaymentPayee } from '@entities/tsp';
import { formatPhoneNumber } from '@shared/lib/phone';
import { Text } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
interface OtpProps {
  showVouchersForm: boolean;
  payee: PaymentPayee;
}
const Otp: FC<OtpProps> = ({
  showVouchersForm,
  payee
}) => {
  const {
    profile
  } = useAuthDataStore();
  const phone = profile?.phone || '';
  const {
    handleConfirmCode,
    isConfirmCodeLoading,
    confirmCodeError,
    setConfirmCodeError
  } = useConfirmCode({
    showVouchersForm,
    payee,
    clearResendCodeError: () => setResendCodeError(null)
  });
  const {
    handleSendCode,
    isResendCodeLoading,
    resendCodeError,
    setResendCodeError
  } = useResendCode({
    clearConfirmCodeError: () => setConfirmCodeError(null)
  });
  const handleChange = () => {
    setConfirmCodeError('');
    setResendCodeError('');
  };
  return <OtpWrapper>
      <TextWrapper>
        <Text family="MTSWide" size={{
        desktop: 'h6',
        mobile: 'pL'
      }} weight="bold" color="primary">
          Введите код
        </Text>
        <Text family="MTSCompact" size={{
        desktop: 'pL',
        mobile: 'pM'
      }} weight="medium" color="secondary" style={{
        textAlign: 'center'
      }}>
          Отправили код подтверждения на&nbsp;номер&nbsp;
          {formatPhoneNumber(phone)}
        </Text>
      </TextWrapper>

      <ConfirmationFieldWrapper>
        <ConfirmationField autoFocus bgLayer isErrorAutoClearEnabled={false} hasError={Boolean(confirmCodeError || resendCodeError)} errorMessage={confirmCodeError || resendCodeError || ''} fieldsCount={5} isLoading={isConfirmCodeLoading || isResendCodeLoading} onChange={handleChange} onComplete={handleConfirmCode} />
      </ConfirmationFieldWrapper>

      <TimerWrapper>
        <Timer isTimerActive duration={30} onSendCodeClick={handleSendCode} />
      </TimerWrapper>
    </OtpWrapper>;
};
export default Otp;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const OtpWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "OtpWrapper",
  class: "o16kgoq4",
  propsAsIs: false,
  vars: {
    "o16kgoq4-0": [_exp()]
  }
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "ttqp2z4",
  propsAsIs: false
});
const ConfirmationFieldWrapper = /*#__PURE__*/styled('div')({
  name: "ConfirmationFieldWrapper",
  class: "c11agr9w",
  propsAsIs: false
});
const TimerWrapper = /*#__PURE__*/styled('div')({
  name: "TimerWrapper",
  class: "t1p6zjl4",
  propsAsIs: false
});

require("./Otp.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Otp.tsx");